import React from 'react'

import { PairState } from '../../domain/multicall'
import type { AddLiquidityControllerResult } from '../../features/liquidity/useAddLiquidityController'
import { PoolPriceBar } from '../../widgets/liquidity/add/PoolPriceBar'
import { MintField as Field } from '../../domain/liquidity'

export function AddLiquidityPricePanel({ controller }: { controller: AddLiquidityControllerResult }) {
  const { currencies, noLiquidity, pairState, poolTokenPercentage, price } = controller

  if (!currencies[Field.CURRENCY_A] || !currencies[Field.CURRENCY_B] || pairState === PairState.INVALID) {
    return null
  }

  return (
    <div className="glass-subtle rounded-xl p-4">
      <div className="mb-2 text-sm font-medium text-muted-foreground">
        {noLiquidity ? 'Initial prices' : 'Prices'} and pool share
      </div>
      <div className="surface-inset rounded-lg p-3">
        <PoolPriceBar
          currencies={currencies}
          poolTokenPercentage={poolTokenPercentage}
          noLiquidity={noLiquidity}
          price={price}
        />
      </div>
    </div>
  )
}

export function AddLiquidityFirstPoolBanner({ controller }: { controller: AddLiquidityControllerResult }) {
  if (!controller.noLiquidity) return null

  return (
    <div className="rounded-lg border border-border bg-muted/20 p-4 text-sm">
      <p className="font-medium">You are the first liquidity provider.</p>
      <p className="mt-1 text-muted-foreground">
        The ratio of tokens you add will set the price of this pool. Once you are happy with the rate click supply to
        review.
      </p>
    </div>
  )
}
